import { DocumentIcon } from '@heroicons/react/24/outline';
import React from 'react';

import {
  EventRow,
  EventText,
  EventUser,
} from '@/components/domain-events-v2/shared';
import { RegistryDefinitions } from '@/components/domain-events-v2/types';
import { BlobLink, MatterLink } from '@/components/entity-links';

export const blobEvents: RegistryDefinitions = {
  blob_created: {
    icon: DocumentIcon,
    iconColor: 'text-gray-500',
    priority: 'medium',
    render: (event) => {
      const { payload } = event;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const matterName = (event as any).matter_name;

      return (
        <EventRow>
          <EventUser event={event} />
          <EventText>uploaded</EventText>
          <BlobLink
            entityId={payload.blob?.id || payload.target_id}
            matterId={event.matter}
            className="font-medium text-gray-900 hover:text-blue-600 transition-colors"
          >
            {payload.blob?.name || 'file'}
          </BlobLink>
          <EventText>to</EventText>
          <MatterLink entityId={event.matter} variant="badge">
            {matterName || 'Matter'}
          </MatterLink>
        </EventRow>
      );
    },
    description: (event) => {
      const p = event.payload;
      return `uploaded file: ${p.blob?.name || 'file'}`;
    },
  },
};
